module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="experience-thumb-wrapper template-thumb-wrapper">\n    <div class="experience-thumb-container" style="cursor: default"></div>\n    <div class="actions-panel">\n        <a id="preview" class="edit-experience btn btn-primary" >Preview</a>\n        <a id="create" class="edit-experience btn btn-primary">Create</a>\n    </div>\n    <div class="experience-meta-data">\n        <div class="title-wrapper">\n            <span class="title-container" data-content="' +
__e( name ) +
'">\n                <span class="title">' +
__e( name ) +
'</span>\n            </span>\n        </div>\n\n        <div class="state">' +
__e( description ) +
'</div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/dashboard/TemplateItemView.tpl
// module id = 2892
// module chunks = 0